import Vue from 'vue'
import Main from '@/main.vue'
import router from '@/router'
import store from '@/store'
import PortalVue from 'portal-vue'
import VueDragScroll from 'vue-dragscroll'
import { Plugin } from 'vue-fragment'

// Plugins
import Components from '@/plugins/components'
import VueKonva from 'vue-konva'
import Meta from 'vue-meta'
import VueSocialSharing from 'vue-social-sharing'

Vue.config.productionTip = false

// Use Plugin
Vue.use(Components)
Vue.use(VueKonva)
Vue.use(PortalVue)
Vue.use(Meta)
Vue.use(VueSocialSharing)
Vue.use(VueDragScroll)
Vue.use(Plugin)

new Vue({
  router,
  store,
  render: h => h(Main),
}).$mount('#app')
